import React, { useMemo } from "react";
import { getDecimalFormat } from "helpers/getNumberFormats";
import { inventoryDictionary } from "helpers/dictionary";
import { UpdatePercentageComponent } from "./UpdatePercentageComponent";
import { InventoriesActions } from "./InventoriesActions";
import { useSelector } from "react-redux";

export const useColumnsStationary = (
  digitalInventory = false,
  inventoryType,
  keyInventory,
  edited
) => {
  const columns = useMemo(() => {
    const cols = [
      {
        Header: "Numero Almacen",
        accessor: "number",
        filterable: true,
        filterMethod: (filter, row) =>
          row.number.toLowerCase().includes(filter.value.toLowerCase()),
      },
      {
        Header: "Numero de Serie",
        accessor: "serialNumber",
        filterable: true,
        filterMethod: (filter, row) =>
          row?.serialNumber?.toLowerCase()?.includes(filter.value.toLowerCase()),
      },
      {
        Header: "Capacidad total",
        accessor: "totalVolume",
        filterable: true,
        filterMethod: (filter, row) =>
          row.totalVolume?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
      },
      {
        Header: "Volumen Actual",
        accessor: "currentVolume",
        Cell: ({ original }) => {
          const currentVolume = parseFloat(original.currentVolume);
          return <div>{getDecimalFormat(currentVolume)} lts</div>;
        },
        filterable: true,
        filterMethod: (filter, row) =>
          row.currentVolume?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
      },
      {
        Header: `Porcentaje ${digitalInventory ? "digital" : "físico"}`,
        accessor: "currentPercentage",
        Cell: ({ original }) => (
          <>
            {digitalInventory ? (
              <div>{original.currentPercentage}</div>
            ) : (
              <UpdatePercentageComponent
                data={original}
                keyInventory={inventoryDictionary.storages}
              />
            )}
          </>
        ),
        filterable: true,
        filterMethod: (filter, row) =>
          row.currentPercentage?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
      },
      {
        Header: "Total KG",
        accessor: "totalKg",
        Cell: ({ original }) => {
          const { inventory: { config } } = useSelector(({ inventories }) => inventories);
          const isNegative = config?.allowsNegativeInventory
          return (
            <div style={{ float: "right", marginRight: 16 }}>
              {original.totalKg !== undefined && (isNegative || original.totalKg !== 0)
                ? getDecimalFormat(original?.totalKg)
                : "0.00"}{" "}
              kg
            </div>
          )
        },
        filterable: true,
        filterMethod: (filter, row) =>
          row.totalKg?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
      },
    ];

    if (digitalInventory) {
      cols.push(
        {
          Header: "Fecha sync",
          accessor: "syncDate",
          filterable: true,
          filterMethod: (filter, row) =>
            row.syncDate?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
        },
        {
          Header: "Acciones",
          Cell: ({ original }) => (
            <InventoriesActions
              original={original}
              inventoryType={inventoryType}
              keyInventory={keyInventory}
              edited={edited}
            />
          ),
        },
      );
    }

    return cols;
  }, [digitalInventory, inventoryType, keyInventory, edited]);

  return columns;
};
